import type { UnifiedIconName } from '@/components/UnifiedIcon';

export interface LoginShowcaseFeature {
  icon: UnifiedIconName;
  title: string;
  description: string;
}

export interface LoginShowcaseAgentPreview {
  label: string;
  task: string;
  status: 'running' | 'ready';
}

/** Marketing copy for the login showcase panel. */
export const LOGIN_SHOWCASE_FEATURES: LoginShowcaseFeature[] = [
  {
    icon: 'RocketLaunch',
    title: 'Deploy in minutes',
    description: 'Launch no-code agents tuned to your workflows.',
  },
  {
    icon: 'PlugsConnected',
    title: 'Connect anything',
    description: 'CRM, comms, and tools via MCP and API connectors.',
  },
  {
    icon: 'ChartLineUp',
    title: 'Measure ROI',
    description: 'Track token spend and business impact in one place.',
  },
  {
    icon: 'Lightning',
    title: 'Always on',
    description: 'Scheduled, triggered, or on-demand agent runtime.',
  },
];

export const LOGIN_SHOWCASE_AGENT_PREVIEWS: LoginShowcaseAgentPreview[] = [
  {
    label: 'Sales copilot',
    task: 'Qualifying inbound leads from HubSpot…',
    status: 'running',
  },
  {
    label: 'Ops assistant',
    task: 'Summarizing stand-up notes for Slack',
    status: 'ready',
  },
];
